import { Box, Grid, SxProps, Theme, Typography } from "@mui/material";

type AlarmEditDetailsHeaderProps = {
  title: string;
  typographySx?: SxProps<Theme>;
};

export function AlarmEditDetailsHeader({
  title,
  typographySx,
}: AlarmEditDetailsHeaderProps) {
  return (
    <Grid
      item
      xs={12}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box sx={{ flexDirection: "row", display: "flex", marginTop: "1%" }}>
        <Typography sx={{ ...typographySx }}>{title}</Typography>
      </Box>
    </Grid>
  );
}
